<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR FORNECEDOR' : 'NOVO FORNECEDOR'" titleIcon="fas fa-edit">

            <div v-if="modoEdicao && !carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" maxlength="120" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="CNPJ / CPF">
                            <el-input v-model="dados.cnpj_cpf" maxlength="30"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Telefone">
                            <el-input v-model="dados.telefone" maxlength="30"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="E-mail">
                            <el-input v-model="dados.email" maxlength="150"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Endereço">
                            <el-input v-model="dados.endereco" maxlength="255"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/almox-fornecedor">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        dados: {
            nome: '',
            situacao: true,
            cnpj_cpf: '',
            telefone: '',
            email: '',
            endereco: ''
        },
        modoEdicao: false,
        carregado: false
    }),
    mounted () {
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        }
    },
    methods: {
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/almox-fornecedor/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/almox-fornecedor/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/almox-fornecedor/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/almox-fornecedor')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
